import React from "react"
import {twMerge} from "tailwind-merge"

import {KLARA_PRESETS, TKlaraPeriod} from "../period"
import {CustomRangePicker} from "./CustomRangePicker"
import {usePresetLabels} from "./periodLabel"

export const PeriodSelector: React.FC<{value: TKlaraPeriod; onChange: (next: TKlaraPeriod) => void}> = ({
  value,
  onChange,
}) => {
  const labels = usePresetLabels()

  return (
    <div className={"flex flex-wrap rounded-[9px] bg-cr-slate-4 p-[3px]"}>
      {KLARA_PRESETS.map(preset => {
        const isActive = value.kind === "preset" && value.preset === preset
        return (
          <button
            key={preset}
            type={"button"}
            aria-pressed={isActive}
            onClick={() => onChange({kind: "preset", preset})}
            className={twMerge(
              "rounded-[7px] px-3 py-1.5 text-xs font-semibold transition-colors",
              isActive ? "bg-cr-blue text-white" : "text-cr-slate-60 hover:text-cr-slate-90"
            )}
          >
            {labels[preset]}
          </button>
        )
      })}
      <CustomRangePicker value={value} onApply={onChange} />
    </div>
  )
}
